import { Service, ServiceStatus } from '@/lib/definitions/api.types'
import { ServiceStatuses } from '@/lib/definitions/serviceStatuses'
import { ProductIdentifiers } from '@/lib/definitions/types'

export const INSIGHTS_ACTIVE_STATUSES: ServiceStatus[] = [
  ServiceStatuses.LIVE,
  ServiceStatuses.READY_FOR_SERVICE,
  ServiceStatuses.TRIAL,
]

export const INSIGHTS_PRODUCTS: ProductIdentifiers[] = [
  ProductIdentifiers.IP_TRANSIT,
  ProductIdentifiers.IP_TRANSIT_OVER_GRE,
]

export const isIpTransitService = (service: Service): boolean =>
  INSIGHTS_PRODUCTS.includes(service.product?.pid as ProductIdentifiers)

export const isActiveIpTransitService = (service: Service): boolean =>
  isIpTransitService(service) &&
  INSIGHTS_ACTIVE_STATUSES.includes(service.status)

export const countIpTransitServices = (services?: Service[]): number =>
  services?.filter(isIpTransitService).length ?? 0

export const countActiveIpTransitServices = (services?: Service[]): number =>
  services?.filter(isActiveIpTransitService).length ?? 0

export const findIpTransitService = (
  services?: Service[]
): Service | undefined => services?.find(isIpTransitService)
